import { API } from "@swivl-mono/api-helper";
import { UserInterface } from "@swivl-mono/types";
import { useOutsideClick } from "@swivl-mono/ui";
import { Dispatch, SetStateAction, memo } from "react";

import SSCopyToClipboard from "../../../../../Components/SSCopyToClipboard/SSCopyToClipboard";
import { AlertsModel } from "../../../../../Models/Notifications/Alerts.Model";
import "./NameRow.scss";

interface MoreDetailsDropdownProps {
  setShowDetails: Dispatch<SetStateAction<boolean>>;
  user: UserInterface;
}

const BaseMoreDetailsDropdown = ({ setShowDetails, user }: MoreDetailsDropdownProps) => {
  const dropdownRef = useOutsideClick(() => setShowDetails(false));
  return (
    <div className="moreDetails" ref={dropdownRef}>
      <SSCopyToClipboard
        copyValue={String(user.id)}
        copiedComponent={
          <div className="moreDetailsItem copied">
            USER ID: {user.id}
            <span>COPIED</span>
          </div>
        }
      >
        <div className="moreDetailsItem">
          USER ID: {user.id}
          <span>COPY</span>
        </div>
      </SSCopyToClipboard>
      {/* <SSCopyToClipboard
            copyValue={item.get("userNumber")}
            copiedComponent={<div className="moreDetailsItem copied">USER #: {item.get("userNumber")}<span>COPIED</span></div>}
            ><div className="moreDetailsItem">USER #: {item.get("userNumber")}<span>COPY</span></div>
         </SSCopyToClipboard> */}

      <SSCopyToClipboard
        copyValue={`${import.meta.env.VITE_STUDIO_URL}/transcript/${user.id}`}
        copiedComponent={
          <div className="moreDetailsItem copied">
            TRANSCRIPT LINK <span>COPIED</span>
          </div>
        }
        onCopy={async () => {
          API.Users.renewTranscriptAccess(user.orgId, user.id);
          AlertsModel.successToast("Link Copied to clipboard. Link will expire in 3 days.");
          setShowDetails(false);
        }}
      >
        <div className="moreDetailsItem">
          TRANSCRIPT LINK <span>COPY</span>
        </div>
      </SSCopyToClipboard>

      {/*         
            {settingBlocked ? <div className="moreDetailsItem blocked"><Spinner /></div> :
            item.get("isBlocked") ? <div className="moreDetailsItem blocked"
            onClick={async () => {setBlocked(false)}}>UNBLOCKED</div> :  <div className="moreDetailsItem blocked"
            onClick={async () => {setBlocked(true)}}>BLOCK USER</div> } */}
    </div>
  );
};

export const MoreDetailsDropdown = memo(BaseMoreDetailsDropdown);
